/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';
import type { LieuFormationAgrementGridDto } from './LieuFormationAgrementGridDto';
import {
    LieuFormationAgrementGridDtoFromJSON,
    LieuFormationAgrementGridDtoFromJSONTyped,
    LieuFormationAgrementGridDtoToJSON,
} from './LieuFormationAgrementGridDto';

/**
 * 
 * @export
 * @interface LieuFormationAgrementGridDtoPaginatedResults
 */
export interface LieuFormationAgrementGridDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof LieuFormationAgrementGridDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<LieuFormationAgrementGridDto>}
     * @memberof LieuFormationAgrementGridDtoPaginatedResults
     */
    results?: Array<LieuFormationAgrementGridDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof LieuFormationAgrementGridDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the LieuFormationAgrementGridDtoPaginatedResults interface.
 */
export function instanceOfLieuFormationAgrementGridDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function LieuFormationAgrementGridDtoPaginatedResultsFromJSON(json: any): LieuFormationAgrementGridDtoPaginatedResults {
    return LieuFormationAgrementGridDtoPaginatedResultsFromJSONTyped(json, false);
}

export function LieuFormationAgrementGridDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): LieuFormationAgrementGridDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(LieuFormationAgrementGridDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function LieuFormationAgrementGridDtoPaginatedResultsToJSON(value?: LieuFormationAgrementGridDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(LieuFormationAgrementGridDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

